// way to discriminated between generic and dedicated engines

import { DedicatedEngine } from '@rossum/api-client/dedicatedEngines';
import { GenericEngine } from '@rossum/api-client/genericEngines';

// another would be to compare their URLs but it seems overkill
export const isDedicatedEngine = (
  engine: DedicatedEngine | GenericEngine
): engine is DedicatedEngine => 'status' in engine;
